import { render } from "./AddProductDialog.vue?vue&type=template&id=10204960&scoped=true"
import script from "./AddProductDialog.vue?vue&type=script&lang=js"
export * from "./AddProductDialog.vue?vue&type=script&lang=js"

import "./AddProductDialog.vue?vue&type=style&index=0&id=10204960&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10204960"]])

export default __exports__